import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { Nil } from '@pbt/pbt-ui-components'

import {
  RX_REQUEST_TASK_TYPE,
  VET_DIET_REQUEST_TASK_TYPE,
} from '~/constants/taskConstants'
import {
  fetchPrescription,
  getPrescriptionById,
} from '~/store/duck/prescriptions'
import { useGetPrescriptionStateType } from '~/store/hooks/prescription'
import { useGetTaskTypeByTaskId } from '~/store/hooks/tasks'
import type { Task } from '~/types'

export const useTaskIsEditable = (task?: Task | Nil): boolean => {
  const dispatch = useDispatch()
  const prescription = useSelector(getPrescriptionById(task?.prescriptionId))
  const { isDraft } = useGetPrescriptionStateType()(prescription?.state?.id)
  const taskType = useGetTaskTypeByTaskId()(task?.id)

  const isPrescriptionRelatedTask =
    taskType === RX_REQUEST_TASK_TYPE || taskType === VET_DIET_REQUEST_TASK_TYPE

  useEffect(() => {
    if (isPrescriptionRelatedTask && task?.prescriptionId) {
      dispatch(fetchPrescription(task.prescriptionId))
    }
  }, [dispatch, isPrescriptionRelatedTask, task?.prescriptionId])

  if (isPrescriptionRelatedTask) {
    return isDraft
  }

  return Boolean(task)
}
